import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'private_params_dialog',
    initialState: { open: false, device_id: null },
    reducers: {
        openPrivateSettings: (state, action) => {
            state.device_id = action.payload;
            state.open = true;
        },
        closePrivateSettings: (state) => {
            state.device_id = null;
            state.open = false;
        },
    },
});
export const { openPrivateSettings, closePrivateSettings } = slice.actions;
export const privateSettingsReducer = slice.reducer;
